// Copyright 2025 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";

export class NotValueConverter implements IValueConverter<boolean, boolean> {
    public toView(value: boolean): boolean {
        return !value;
    }

    public fromView(value: boolean): boolean {
        return !value;
    }
}
